const state = {
  type: 'Payday',
  id: 1
}

const getters = {}

const mutations = {
  SET_DATA (state, data) {
    state.id = data.id
    state.type = data.type
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
